import { render, staticRenderFns } from "./dealApostilleFlow.vue?vue&type=template&id=dec3ba60&"
import script from "./dealApostilleFlow.vue?vue&type=script&lang=js&"
export * from "./dealApostilleFlow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports